import Swiper from 'swiper';
import { Thumbs, Navigation } from 'swiper/modules';

export default () => {
  const similarSlider = document.getElementById('similar-slider');

  if (similarSlider) {
    new Swiper(similarSlider, {
      slidesPerView: 1.2,
      centeredSlides: false,
      freeMode: true,
      spaceBetween: 20,
      grabCursor: true,
      breakpoints: {
        400: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 2.5,
          spaceBetween: 40,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });
  }

  const projectsSlider = document.getElementById('projects-slider');

  if (projectsSlider) {
    new Swiper(projectsSlider, {
      slidesPerView: 1.2,
      centeredSlides: false,
      freeMode: true,
      spaceBetween: 20,
      grabCursor: true,
      breakpoints: {
        400: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
      },
    });
  }

  const servicesSlider = document.getElementById('services-slider');

  if (servicesSlider) {
    new Swiper(servicesSlider, {
      slidesPerView: 1.2,
      centeredSlides: false,
      freeMode: true,
      spaceBetween: 20,
      grabCursor: true,
      breakpoints: {
        400: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 2.3,
        },
        992: {
          slidesPerView: 2.7,
          spaceBetween: 30,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },
    });
  }

  const homeSlider = document.getElementById('home-slider');

  if (homeSlider) {
    const homeSliderThumbsInstance = new Swiper('#home-slider-thumbs', {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 2.5,
      breakpoints: {
        768: {
          slidesPerView: 5.2,
        },
        992: {
          slidesPerView: 5.5,
          spaceBetween: 20,
        },
        1100: {
          slidesPerView: 5.8,
          spaceBetween: 20,
        },
      },
    });

    const homeSliderImages = new Swiper('#home-slider', {
      modules: [Thumbs],
      slidesPerView: 1,
      freeMode: true,
      thumbs: {
        swiper: homeSliderThumbsInstance,
      },
    });

    const projectsSliderEl = document.getElementById('home-slider-projects');
    const projectsSliderNav = projectsSliderEl
      .closest('.projects-slider-container')
      .querySelector('.projects-slider-nav');

    const homeSliderProjects = new Swiper(projectsSliderEl, {
      modules: [Navigation, Thumbs],
      slidesPerView: 1,
      freeMode: true,
      autoHeight: true,
      thumbs: {
        swiper: homeSliderImages,
      },
      navigation: {
        prevEl: projectsSliderNav.querySelector('.projects-slider-nav__prev'),
        nextEl: projectsSliderNav.querySelector('.projects-slider-nav__next'),
      },
    });

    const onSlideChange = (slider) => {
      return homeSliderProjects.slideTo(slider.activeIndex);
    };

    homeSliderImages.on('slideChange', onSlideChange);
  }
};
